import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';
import 'antd/dist/antd.css'
import './static/css/normalize.css'
// import Login from './page/Login/Login';
import Home from './page/Home/Home';
import serviceWorker from './serviceWorker';

import { ConfigProvider } from 'antd';
import zh_CN from 'antd/es/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

ReactDOM.render(
    <ConfigProvider  locale={zh_CN}>
        <HashRouter>
            <Switch>
                {/* <Route path="/Login" component={Login} /> */}
                <Route path="/Home" component={Home} />
                <Route path="/" render={(props) =>
                    <Home {...props} />
                }>
                </Route>
            </Switch>
        </HashRouter>
    </ConfigProvider >,
    document.getElementById('root'));
serviceWorker();
